module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_3016.e729b82f.png";